import React, { FC } from "react";
import { AdminPlansView } from "../../components";

export const AdminPlansPage: FC = () => {
  return <AdminPlansView />;
};
